import { RunElement } from '../../shared/run-element.js';
import { skinResolutionMixin } from '../../shared/skin-resolution-mixin.js';
import * as defaultSkin from './skins/icon.default.js';

const VALID_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
const DEFAULT_SIZE = 'md';

class RunIcon extends skinResolutionMixin(RunElement) {
  #name = '';
  #size = DEFAULT_SIZE;
  #label = '';

  static defaultSkin = defaultSkin;

  static skinLoaders = {
    wireframe: () => import('./skins/icon.wireframe.js'),
  };

  static get observedAttributes() {
    return ['name', 'size', 'label'];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.#updateAria();
    this.requestUpdate();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    switch (name) {
      case 'name':  this.name = newValue === null ? '' : newValue; break;
      case 'size':  this.size = newValue === null ? DEFAULT_SIZE : newValue; break;
      case 'label': this.label = newValue === null ? '' : newValue; break;
    }
  }

  get name() { return this.#name; }
  set name(value) {
    const coerced = String(value ?? '').trim();
    if (this.#name === coerced) return;
    this.#name = coerced;
    if (coerced) {
      this.setAttribute('name', coerced);
    } else {
      this.removeAttribute('name');
    }
    this.requestUpdate();
  }

  get size() { return this.#size; }
  set size(value) {
    const coerced = String(value ?? '').trim();
    const resolved = VALID_SIZES.includes(coerced) ? coerced : DEFAULT_SIZE;
    if (this.#size === resolved) return;
    this.#size = resolved;
    this.setAttribute('size', resolved);
    this.requestUpdate();
  }

  get label() { return this.#label; }
  set label(value) {
    const coerced = String(value ?? '').trim();
    if (this.#label === coerced) return;
    this.#label = coerced;
    if (coerced) {
      this.setAttribute('label', coerced);
    } else {
      this.removeAttribute('label');
    }
    this.#updateAria();
    this.requestUpdate();
  }

  updated(changedProperties) {
    super.updated?.(changedProperties);
    this.#updateAria();
  }

  #updateAria() {
    if (this.#label) {
      this.setAttribute('role', 'img');
      this.setAttribute('aria-label', this.#label);
      this.removeAttribute('aria-hidden');
    } else {
      this.removeAttribute('role');
      this.removeAttribute('aria-label');
      this.setAttribute('aria-hidden', 'true');
    }
  }
}

if (!customElements.get('run-icon')) {
  customElements.define('run-icon', RunIcon);
}

export { RunIcon };
export default RunIcon;